import React from "react"

const BathIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_12988_10977)">
        <path
          d="M4.5 12V13.5"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 12V13.5"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 6H8.5V9H12.5V6Z"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 6.5H14.5C14.6326 6.5 14.7598 6.55268 14.8536 6.64645C14.9473 6.74021 15 6.86739 15 7V9C15 9.79565 14.6839 10.5587 14.1213 11.1213C13.5587 11.6839 12.7956 12 12 12H4C3.20435 12 2.44129 11.6839 1.87868 11.1213C1.31607 10.5587 1 9.79565 1 9V7C1 6.86739 1.05268 6.74021 1.14645 6.64645C1.24021 6.55268 1.36739 6.5 1.5 6.5H8.5"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 6.5V3.25C3.5 2.91848 3.6317 2.60054 3.86612 2.36612C4.10054 2.1317 4.41848 2 4.75 2C5.04111 1.99932 5.32373 2.09808 5.55105 2.27994C5.77837 2.4618 5.93676 2.71584 6 3"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12988_10977">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BathIcon
